import { Event, SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';
import { ProductSearchAction, TextSearchAction } from '../../types/actions/SearchActions';
import { ProductPaginatedResult } from 'shared/types/result';
import { ProductQuery } from 'shared/types/query/ProductQuery';

export type SearchActions = {
  productSearch: ProductSearchAction;
  textSearch: TextSearchAction;
};

export const getSearchActions = (sdk: SDK<ComposableCommerceEvents>): SearchActions => {
  return {
    productSearch: async (
      query: ProductQuery,
      options: { parallel?: boolean; customHeaderValue?: string; serverOptions?: ServerOptions } = {},
    ) => {
      const response = await sdk.callAction<ProductPaginatedResult>({
        actionName: 'search/productSearch',
        parallel: options.parallel,
        query,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      if (!response.isError) {
        sdk.trigger(
          new Event({
            eventName: 'searchProductQueried',
            data: {
              query: { ...query },
              result: response.data,
            },
          }),
        );
      }
      return response;
    },
    textSearch: async (
      payload: TextSearchPayload,
      query?: ProductQuery,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<ProductPaginatedResult>({
        actionName: 'search/textSearch',
        payload,
        query,
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      if (!response.isError) {
        sdk.trigger(
          new Event({
            eventName: 'textSearchQueried',
            data: {
              payload,
              result: response.data,
            },
          }),
        );
      }
      return response;
    },
  };
};
